import { Controller } from "@hotwired/stimulus"
import Hls from 'hls.js'

export default class extends Controller {
  static targets = [
    'video'
  ]

  connect() {
    if (!Hls.isSupported()) { return }
    if (this.videoTarget.getAttribute('src').endsWith('.mp4')) { return }
    if (this.videoTarget.getAttribute('src').endsWith('.mov')) { return }

    this.hls = new Hls()
    this.hls.on(Hls.Events.MEDIA_ATTACHED, function () {
      // console.log('video and hls.js are now bound together !')
    })
    this.hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
      // console.log('manifest loaded, found ' + data.levels.length + ' quality level')
    })
    this.hls.loadSource(this.videoTarget.getAttribute('src'))
    this.hls.attachMedia(this.videoTarget)
  }
}
